import ReactGA from 'react-ga4';

// ID de medición de Google Analytics 4
// Formato: G-XXXXXXXXXX
const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-XXXXXXXXXX';

// Inicializar Google Analytics 4
export const initGA = () => {
  if (MEASUREMENT_ID && MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(MEASUREMENT_ID, {
      gaOptions: {
        anonymizeIp: true,
      },
      gtagOptions: {
        send_page_view: true,
      },
    });
    console.log('Google Analytics 4 initialized');
  } else {
    console.log('Google Analytics 4 not configured (using placeholder ID)');
  }
};

// Rastrear vista de página
export const trackPageView = (path, title) => {
  ReactGA.send({ hitType: 'pageview', page: path, title: title });
};

// Eventos personalizados para tu app de alérgenos
export const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Evento: Usuario instaló la PWA
export const trackPWAInstall = () => {
  trackEvent('PWA', 'install', 'User installed PWA');
};

// Evento: Usuario escaneó un producto
export const trackProductScan = (barcode, productName, safe) => {
  trackEvent('Product', 'scan', `${productName} (${barcode})`, safe ? 1 : 0);
};

// Evento: Usuario configuró alérgenos
export const trackAllergenConfig = (allergenCount) => {
  trackEvent('Allergen', 'configure', 'Allergens configured', allergenCount);
};

// Evento: Usuario guardó perfil
export const trackProfileSave = (profileName) => {
  trackEvent('Profile', 'save', profileName);
};

// Evento: Usuario cargó perfil
export const trackProfileLoad = (profileName) => {
  trackEvent('Profile', 'load', profileName);
};

// Evento: Usuario añadió a favoritos
export const trackAddFavorite = (productName) => {
  trackEvent('Favorite', 'add', productName);
};

// Evento: Usuario quitó de favoritos
export const trackRemoveFavorite = (productName) => {
  trackEvent('Favorite', 'remove', productName);
};

// Evento: Usuario envió sugerencia
export const trackSuggestion = (type) => {
  trackEvent('Suggestion', 'send', type);
};

// Evento: Usuario cambió idioma
export const trackLanguageChange = (language) => {
  trackEvent('Settings', 'language_change', language);
};

// Evento: Usuario usó cámara para escanear
export const trackCameraUsage = () => {
  trackEvent('Scanner', 'camera_start', 'User started camera');
};

// Evento: Usuario escaneó alérgeno personalizado
export const trackCustomAllergen = (allergenName) => {
  trackEvent('Allergen', 'custom_add', allergenName);
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackPWAInstall,
  trackProductScan,
  trackAllergenConfig,
  trackProfileSave,
  trackProfileLoad,
  trackAddFavorite,
  trackRemoveFavorite,
  trackSuggestion,
  trackLanguageChange,
  trackCameraUsage,
  trackCustomAllergen,
};
